<template>
  <SubRuiYunRslEvManagementUser ref="SubRuiYunRslEvManagementUser"></SubRuiYunRslEvManagementUser>
</template>

<script>
import SubRuiYunRslEvManagementUser from '@/componentsSubVue/SubRuiYunRslEvManagementUser.vue'
export default {
  components: {
    SubRuiYunRslEvManagementUser
  },
}
</script>

<style>
</style>
